import React, { useContext } from 'react';
import { IWatchContext, WatchContext } from '../../../watchState/watchContext';
import SearchField from 'components/SearchField/SearchField';

export const Search: React.FC = () => {
	const { changeSearchString, searchString, watches } = useContext<IWatchContext>(WatchContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={watches.count ? 800 : undefined}
		/>
	);
};
